module.exports = __webpack_public_path__ + "img/cart0.570c3dd1.png";